import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import NO_OUT_Component from "../NO_OUT_Component";
import EmptyLine from "../../EmptyLine";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultBody from "../../Table/ResultBody";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBodyCell from "../../Table/ResultBodyCell";
import {useModal} from "../../../Context/ModalContext";
import CheckCSName from "../../CheckCSName";
import StationElevationPlot from "../UI/StationElevationPlot";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultView from "../../V2/ResultView";

export function B30({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const StaElevPlot = ({riverStation, globalVariables, layers}) => {

    return (
        <>
            <>
                <StationElevationPlot
                    mode={2}
                    crossSection={`${riverStation?.us_name} (US)`}
                    plotData={{
                        base: riverStation?.plot_us,
                    }}
                    globalVariables={globalVariables}
                    layers={layers}
                />
                <StationElevationPlot
                    mode={2}
                    crossSection={`${riverStation?.ds_name} (DS)`}
                    plotData={{
                        base: riverStation?.plot_ds,
                    }}
                    globalVariables={globalVariables}
                    layers={layers}
                />
            </>
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()

    switch (row.error_id) {
        case MessageCodes.Internal.SOF01.error_id: {
            return (
                <>
                    <ResultText>
                        Ineffective flow areas do not act consistently at the US and DS cross sections of the following structures for the listed profiles.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(20)}}>Structure</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(30)}}>Profile</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName
                                                csName={(
                                                    <>
                                                        {r.type} at RS {r.cross_section}
                                                    </>
                                                )}
                                                csNameVal={r.cross_section}
                                            />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{r.profiles?.join(', ')}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.B30_NOOUT01.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B30_NOOUT02.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}